module.exports = __webpack_public_path__ + "static/media/plane(6).fa15687d.PNG";